module.exports = __webpack_public_path__ + "img/dinh-gia-doanh-nghiep.e6af5441.png";